import './InnovationCard.css';
import { getImageSrc } from '../../utils/imageUtils';

export default function InnovationCard({ logo_url, title, description }) {
  const iconBase = process.env.PUBLIC_URL || '';
  const logoSrc = getImageSrc(logo_url, { fallback: `${iconBase}/aws.svg` });
  const checkSrc = getImageSrc(`${iconBase}/check_icon.svg`);
  const logoAlt = title ? `${title} logo` : 'Innovation logo';

  return (
    <article className="InnovationCard">
      <div className="InnovationCard__header">
        <img
          className="InnovationCard__logo"
          src={logoSrc}
          alt={logoAlt}
          loading="lazy"
          decoding="async"
        />
        <img
          className="InnovationCard__check"
          src={checkSrc}
          alt="Completed"
        />
      </div>
      <div className="InnovationCard__content">
        {title ? <h3 className="InnovationCard__title">{title}</h3> : null}
        {description ? <p className="InnovationCard__description">{description}</p> : null}
      </div>
    </article>
  );
}
